import { render, staticRenderFns } from "./FileLinkBtn.vue?vue&type=template&id=8365d5f6&scoped=true&"
import script from "./FileLinkBtn.vue?vue&type=script&lang=js&"
export * from "./FileLinkBtn.vue?vue&type=script&lang=js&"
import style0 from "./FileLinkBtn.vue?vue&type=style&index=0&id=8365d5f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8365d5f6",
  null
  
)

export default component.exports